module.exports = __webpack_public_path__ + "img/slide03.9d5c7824.jpg";